var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"site-footer"},[_c('div',{staticClass:"footer-bar"},[_c('span',[_vm._v("© 2024-2026 快捷工具箱")]),_c('span',[_c('i',{staticClass:"el-icon-time"}),_vm._v(" 已稳定运行 "+_vm._s(_vm.uptimeDays)+" 天")]),_c('span',[_c('i',{staticClass:"el-icon-view"}),_vm._v(" 累计访问 "+_vm._s(_vm.status.totalVisits)+" 次")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }